import styled from "styled-components"

export const Content = styled.div`
  height: var(--footer-height);
  background-color: var(--footer-background);
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const FooterBlock = styled.div`
  background: rgba(45, 45, 45, 0.9);
  backdrop-filter: blur(4px);

  & ::-webkit-scrollbar {
    width: 4px;
    height: 2px;
  }

  & ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.4);
    border-radius: 2px;
    backdrop-filter: blur(4px);
  }

  & ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.7);
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #636262;
    border-radius: 2px;
  }

  & .footer-text {
    max-width: 320px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #c0c0c0;
  }
  @media screen and (max-width: 950px) {
    .footer-text {
      display: none !important;
    }
  }
`
